import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core'
import { WidgetInterface } from '@modules/widgets-module/interfaces/widget.interface'
import { OrdersSettingsInterface } from '@shared/components/trading/widgets/orders-widget/core/interfaces/orders-settings.interface'
import { AssetClassEnum } from '@modules/positions-module/enums/asset-class.enum'
import { OrdersStocksComponent } from '@shared/components/trading/orders/orders-stocks/orders-stocks.component'
import { OrdersOptionsComponent } from '@shared/components/trading/orders/orders-options/orders-options.component'

@Component({
	selector: 'app-orders',
	templateUrl: './orders.component.html',
	styleUrl: './orders.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [OrdersStocksComponent, OrdersOptionsComponent],
})
export class OrdersComponent {
	protected readonly assetClassEnum = AssetClassEnum

	public widget: InputSignal<WidgetInterface<OrdersSettingsInterface> | null> =
		input.required<WidgetInterface<OrdersSettingsInterface> | null>()
}
